import {
  ADD_SALON_SUCCESS,
  GET_SALON_SERVICES_SUCCESS,
  GET_SALON_ALL_APPOINTMENTS_SUCCESS,
  SET_PROFILE_IMAGE,
} from "../constants";

const initialState = {
  salonDetails: {},
  salonServices: [],
  salonAppointments: [],
  uploadedImages: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SALON_SUCCESS:
      return { ...state, salonDetails: {} };
    case GET_SALON_SERVICES_SUCCESS:
      return {
        ...state,
        salonServices: action.data,
      };
    case GET_SALON_ALL_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        salonAppointments: action.data,
      };
    default:
      return state;
  }
};

export default reducer;
